import { BaseWebComponent } from "../base-components/base-web-component.js";
import { authStore } from "./AuthStore.js";
import { LoginForm } from "./login-form.js";
import { PasswordRecoveryForm } from "./password-recovery-form.js";

export class LoginComponent extends BaseWebComponent {
    static webComponentName: string = 'login-component';
    protected _templateId: string = 'login-component';
    /**
     * Email dell'utente che sta tentando di effettuare il login
     * dichiarata qui per essere condivisa con i componenti figli
     */
    private _email: string = '';
    public get email(): string {
        return this._email;
    }
    public set email(value: string) {
        this._email = value;
    }
    get redirectUrl(): string {
        return this.getAttribute('data-redirect') || '/';
    }
    get isFullyAuthenticated(): boolean {
        return authStore.isFullyAuthenticated;
    }
    get requiresTotpSetup(): boolean {
        return authStore.requiresTotpSetup;
    }
    get requiresTotpCode(): boolean {
        return authStore.requiresTotpCode;
    }
    get isPendingTotp(): boolean {
        return authStore.isPendingTotp;
    }
    get isPasswordRecovery(): boolean {
        return authStore.isPasswordRecovery;
    }
    set isPasswordRecovery(value: boolean) {
        if (value) {
            authStore.authState = 'password_recovery';
        } else {
            authStore.authState = 'unauthenticated';
        }
        this.render();
    }
    get currentFlowStep(): string {
        return authStore.currentFlowStep;
    }
    get currentTitle() {
        if (this.requiresTotpSetup) return "Configura autenticazione a due fattori";
        if (this.requiresTotpCode) return "Inserisci codice di verifica";
        if (this.isFullyAuthenticated) return "Accesso completato";
        return "Login";
    };
    get currentIcon() {
        if (this.requiresTotpSetup) return "bi-shield-plus";
        if (this.requiresTotpCode) return "bi-shield-lock";
        if (this.isFullyAuthenticated) return "bi-check-circle";
        return "bi-shield";
    };
    handleLoginResponse(response: any) {
        // Gestisci la risposta del login
    }
    handleSetupComplete() {
        authStore.loginFlow = null;
        authStore.authState = "authenticated";
    }
    handleCodeVerified() {
        console.log("TOTP code verified");
    }
    protected onConnected(): void {
        authStore.initialize();
        window.addEventListener('auth-is-fully-authenticated-changed', (e: CustomEvent) => {
            // Reindirizza alla pagina specificata dopo il login
            if (e.detail.newValue === true) {
                window.location.href = this.redirectUrl;
            }
        });
       
        // this.render();
    }
    protected buildRenderingData(): Record<string, any> {
        return {
            currentTitle:this.currentTitle,
            isPendingTotp: this.isPendingTotp,
            isPasswordRecovery: this.isPasswordRecovery,
            requiresTotpSetup: this.requiresTotpSetup,
            requiresTotpCode: this.requiresTotpCode,
            isFullyAuthenticated: this.isFullyAuthenticated,
            currentIcon: this.currentIcon,
            currentFlowStep: this.currentFlowStep,
            redirectUrl: this.redirectUrl
        }
    }
    protected afterRender(): void {
         window.addEventListener('auth-state-changed', () => {
            this.render();
        });
    }
    static registerElement() {
        super.registerElement();
        LoginForm.registerElement();
        PasswordRecoveryForm.registerElement();
        // console.log(`${this.webComponentName} registered`);
    }
}